module.exports = __webpack_public_path__ + "img/Case_7.a822b0bc.jpg";